import React, { useState, useEffect } from 'react';
import { CardBody, Button, Col, Row, FormGroup, Label, Input } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTable from './DataReactTable';
import ReactTableActions from './ReactTableActions';
import Tooltip from '@material-ui/core/Tooltip';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import ModalMat from '@material-ui/core/Modal';
import { DatePicker, KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { TextField, ThemeProvider, createMuiTheme } from '@material-ui/core';


const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const SpecialitiesList = () => {
    const [specialitiesList, setSpecialitiesList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [speciality, setSpeciality] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [dateOpening, setDateOpening] = useState(new Date())
    const [fileSpeciality, setFileSpeciality] = useState(null);
    const [idSpeciality, setIdSpeciality] = useState(0)
    const [isUpdating, setIsUpdating] = useState(false);
    const [errors, setErrors] = useState({});
    const [specialityGet, setSpecialityGet] = useState({});
    const [codeSpecialist, setCodeSpecialist] = useState(null);


    useEffect(() => {
        loadSpecialities();
        if (specialityGet != null && specialityGet != undefined && specialityGet != {}) {
            setSpeciality(specialityGet.especialidad);
            setDateOpening(specialityGet.fecha_apertura);
            setCodeSpecialist(specialityGet.codigo);
        }
    }, [idSpeciality, specialityGet]);

    const validate = (specialtyData, dateOpeningData, codeSpecialistData) => {
        const errors = {};

        if (specialtyData == null || specialtyData == undefined || specialtyData == "") {
            errors.speciality = 'El campo Especialidad no debe estar vacio';
        }

        if (dateOpeningData == null || dateOpeningData == undefined || dateOpeningData == "") {
            errors.dateOpening = 'El campo fecha no debe estar vacio';
        }

        if (codeSpecialistData == null || codeSpecialistData == undefined || codeSpecialistData == "") {
            errors.codeSpecialist = 'El campo codigo de especialidad no debe estar vacio';
        }

        /*  if (!values.file == null) {
             errors.file = "Seleccione un archivo";
         } else {
             errors.file = "";
         } */

        return errors;
    };

    const loadSpecialities = async () => {
        setIsLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                setSpecialitiesList(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const createSpeciality = () => {

        setOpenModal(false);

        let errors = validate(speciality, dateOpening, codeSpecialist);

        var dataFile = new FormData();
        dataFile.append("especialidad", speciality);
        dataFile.append("fecha_apertura", moment(dateOpening).format("YYYY/MM/DD"));
        dataFile.append("imagen", fileSpeciality);
        dataFile.append("codigo", codeSpecialist);

        setErrors(errors);

        if (Object.entries(errors).length === 0) {

            fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/create', {
                method: 'POST',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: dataFile
            }).then(response => {
                return response.text();
            }).then(data => {
                alert("Especilalidad Agregada Correctamente")
                loadSpecialities();
            }).catch((error) => {
                console.error('Error:', error);
            });
        }

    }


    const updateSpeciality = () => {
        let fechaOpening = moment(dateOpening).format('YYYY-MM-DD');

        const dataToSend = {
            id: idSpeciality,
            especialidad: speciality,
            fecha_apertura: dateOpening,
            imagen: fileSpeciality
        };

        var dataFile = new FormData();
        dataFile.append("id", idSpeciality)
        dataFile.append("especialidad", speciality);
        dataFile.append("fecha_apertura", fechaOpening);
        dataFile.append("imagen", fileSpeciality);
        dataFile.append("codigo", codeSpecialist);

        console.log("SPECIAL", specialityGet)

        fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/update', {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataFile
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                //alert("Especilalidad Actualizada Correctamente")
                loadSpecialities();
                setIdSpeciality(0)
                setOpenModal(false)
                setDateOpening(new Date())
                setSpeciality('')
                //fileSpeciality(null)
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    const reactTableData = {
        tableHeaderData: [{
            Header: '#',
            accessor: 'id_especialidad',
            disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'ESPECIALIDAD',
            accessor: 'especialidad',
        },
        {
            Header: 'CODIGO DE ESPECIALIDAD',
            accessor: 'codigo',
        },
        {
            Header: 'FECHA DE HABILITACIÓN',
            accessor: 'fecha_apertura',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("YYYY/MM/DD") : null}</label>
            )
        },

        ],
        tableRowsData: specialitiesList
    };


    return (
        <CardBody>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    style={{ marginTop: 10 }}
                    color="primary"
                    onClick={() => {
                        setOpenModal(true);
                    }}>
                    Agregar
                </Button>
            </div>
            {isLoading ?
                <div className="text-center">
                    <Spinner animation="border" variant="success" />
                </div>
                :
                <DataReactTable title={''}
                    refresh={loadSpecialities}
                    reactTableData={reactTableData}
                    ReactTableActions={ReactTableActions}
                    setOpenModal={setOpenModal}
                    setIdSpeciality={setIdSpeciality}
                    updateSpeciality={updateSpeciality}
                    setSpecialityGet={setSpecialityGet}
                />
            }
            <ModalMat
                open={openModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <h4 className="bold-text">Especialidad</h4>
                    </div>
                    <div className="form">
                    </div>
                    <form className="material-form" >

                        <Row md={12}>
                            <Col md={4}>
                                <TextField
                                    id="second-telephone-standard-required"
                                    label="Nombre"
                                    type="text"
                                    className="material-form__field"
                                    style={{ width: 300, marginLeft: 20 }}
                                    value={speciality}
                                    onChange={(e) => {
                                        setSpeciality(e.target.value);
                                        console.log(e.target.value)
                                    }}
                                    error={errors.hasOwnProperty("speciality") ? errors.speciality !== "" : false}
                                    helperText={errors.speciality}
                                />
                            </Col>

                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <KeyboardDatePicker
                                            disableFuture
                                            label="Fecha de apertura del servicio"
                                            value={dateOpening}
                                            //disabled={this.state.disabledInput}
                                            className='medical-material-form__field'
                                            onChange={(date) => {
                                                setDateOpening(date)
                                            }}
                                            animateYearScrolling
                                            format="DD/MM/YYYY"
                                            style={{ width: 300, marginLeft: 20 }}
                                            //className={classes.date}
                                            error={errors.hasOwnProperty("dateOpening") ? errors.dateOpening !== "" : false}
                                            helperText={errors.dateOpening}
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>

                            <Col md={4}>
                                <TextField
                                    id="second-telephone-standard-required"
                                    label="Codigo"
                                    type="text"
                                    className="material-form__field"
                                    style={{ width: 300, marginLeft: 20 }}
                                    value={codeSpecialist}
                                    onChange={(e) => {
                                        setCodeSpecialist(e.target.value);
                                    }}
                                />
                            </Col>

                            <Col md={4}>
                                <FormGroup>
                                    <Label for="exampleFile">Imagen de la habilitación</Label>
                                    <Input
                                        type="file"
                                        name="file"
                                        id="exampleFile"
                                        //value={fileSpeciality}
                                        onChange={(e) => {
                                            setFileSpeciality(e.target.files[0])
                                            console.log(e.target.files[0])
                                        }}
                                    /* error={errors.hasOwnProperty("fileSpeciality") ? errors.fileSpeciality !== "" : false}
                                    helperText={errors.fileSpeciality} */
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                <Button
                                    style={{ marginTop: 10 }}
                                    color="primary"
                                    onClick={() => {
                                        setIdSpeciality(0);
                                        setOpenModal(false);
                                    }}
                                >
                                    Cerrar
                                </Button>
                                <Button
                                    color="primary"
                                    style={{ marginTop: 10 }}
                                    disabled={speciality == null && dateOpening == null ? true : false}
                                    onClick={() => {
                                        if (idSpeciality != 0) {
                                            updateSpeciality();
                                            setIdSpeciality(0);
                                        } else {
                                            createSpeciality();
                                        }
                                    }
                                    }>
                                    {idSpeciality != 0 ? "Editar" : "Guardar"}
                                </Button>
                            </Col>

                        </Row>
                    </form>

                </div>

            </ModalMat>
        </CardBody>
    );

}

export default SpecialitiesList;
